import React, { useState, useEffect } from 'react';
import { BundleProps } from 'utils/types';
import {
  StyledLoadComplete,
  StyledLoadCompleteEmblem,
  StyledLoadCompletePriceContainer,
} from './style';
import { LoadCompleteProducts } from './Products';
import { BundlePrice } from 'components/BundlePrice';
import { useGetBadge } from 'utils/useGetBadge';
import { BadgeData, IEmblemBadge } from 'components/Badge/types';
import { SpecialOfferProps } from 'templates/SpecialOffer/types';
import { EBadgeType, EBundlesInternalViewModel } from 'utils/enums';

interface ILoadCompleteGeneralProps {
  prices: BundleProps['prices'];
  productList: BundleProps['productList'];
  backgroundSrc: BundleProps['backgroundSrc'];
  backgroundColor: BundleProps['backgroundColor'];
  emblemBadges: BundleProps['emblemBadges'];
  selectOffer?: SpecialOfferProps['selectOffer'];
  dataTestId?: string;
  isFree?: boolean;
  availability?: {
    total: number;
    remaining: number;
  };
  timer?: string;
  className?: string;
  badges?: BadgeData[];
}

export const LoadCompleteGeneral: React.FC<ILoadCompleteGeneralProps> = ({
  prices,
  dataTestId,
  productList,
  backgroundSrc,
  backgroundColor = {
    colorOne: '#E2AE54',
  },
  emblemBadges = [],
  selectOffer,
  isFree,
  badges = [],
  availability,
  timer,
  className,
}) => {
  const [emblemBadgeOld, setEmblemBadgeOld] = useState<any>(null);
  const emblemBadgeNew = useGetBadge<IEmblemBadge>(emblemBadges);

  useEffect(() => {
    if (Array.isArray(badges) && badges.length > 0) {
      const foundEmblem = badges?.find((b: BadgeData) => {
        return (
          b.badge?.type === EBadgeType.EMBLEM || b.type === EBadgeType.EMBLEM
        );
      });
      setEmblemBadgeOld(foundEmblem?.badge?.emblem || foundEmblem?.emblem);
    } else {
      setEmblemBadgeOld(null);
    }
  }, [badges]);

  const emblem = emblemBadgeNew ?? emblemBadgeOld;

  return (
    <StyledLoadComplete
      className={className || ''}
      backgroundSrc={backgroundSrc}
      backgroundColor={backgroundColor}
      onClick={selectOffer}
      data-testid={dataTestId}
    >
      {emblem?.imageUrl && (
        <StyledLoadCompleteEmblem className="emblem-badge">
          <img alt={'emblem-badge'} src={emblem.imageUrl} />
        </StyledLoadCompleteEmblem>
      )}
      <LoadCompleteProducts productList={productList} />
      <StyledLoadCompletePriceContainer className={'price-container'}>
        {timer && <div className="timer">{timer}</div>}
        <BundlePrice
          prices={prices}
          type={EBundlesInternalViewModel.LOAD_COMPLETE}
          isFree={isFree}
          isTextAutoResized={true}
        />
        {availability && (
          <div className="availability">
            {availability.remaining} / {availability.total}
          </div>
        )}
      </StyledLoadCompletePriceContainer>
    </StyledLoadComplete>
  );
};
